import React, { memo } from "react";
import useCreateMerchantBannerForm from "./index.hooks";
import { Grid } from "@material-ui/core";
import { AppButton, AppPaper, AppTextField } from "../index";
import UploadFile from "../UploadFile";
import cn from "classnames";

type CreateMerchantBannerFormProps = {};

const CreateMerchantBannerForm = ({}: CreateMerchantBannerFormProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    register,
    errors,
    onSubmit,
    uploadLogo,
    handleDialogClose,
    imageB64,
    isLoading,
    watch,
    t,
  } = useCreateMerchantBannerForm();

  return (
    <form onSubmit={onSubmit}>
      <Grid container direction="column" justify="space-between">
        <AppPaper className={styles.tabContent}>
          <Grid item>
            <UploadFile
              maxFileSize={1000000}
              filesLimit={1}
              label={t("Banner")}
              name="imageUri"
              dropzoneText={t(
                "Trascina qui un'immagine o clicca per caricarne una!",
              )}
              onChange={uploadLogo}
              error={!!errors["imageUri"]}
              helperText={errors["imageUri"]?.message}
              inputRef={register}
            />
          </Grid>
        </AppPaper>
      </Grid>
      <AppButton
        disabled={isLoading}
        onClick={handleDialogClose}
        color="secondary"
      >
        Annulla
      </AppButton>
      <AppButton
        className={cn(
          styles.submitEventButton,
          Object.keys(errors).length !== 0
            ? styles.submitEventErrorAnimation
            : null,
        )}
        disabled={isLoading || Object.keys(errors).length !== 0}
        variant="contained"
        color="primary"
        type="submit"
      >
        {t("Applica")}
      </AppButton>
    </form>
  );
};

export default memo(CreateMerchantBannerForm);
